import { CanRegisterFeatureDTO } from "./CanRegisterFeatureDTO";
import { CheckoutFeatureDTO } from "./CheckoutFeatureDTO";
import { CommunicationFeatureDTO } from "./CommunicationFeatureDTO";
import { CoursesCatalogFeatureDTO } from "./CoursesCatalogFeatureDTO";
import { DisableFeaturedFeatureDTO } from "./DisableFeaturedFeatureDTO";
import { DisableMyCoursesFeatureDTO } from "./DisableMyCoursesFeatureDTO";
import { EditCustomerEmailFeatureDTO } from "./EditCustomerEmailFeatureDTO";
import { ExternalCatalogFeatureDTO } from "./ExternalCatalogFeatureDTO";
import { GamificationFeatureDTO } from "./GamificationFeatureDTO";
import { MatchFeatureDTO } from "./MatchFeatureDTO";
import { NoPricingFeatureDTO } from "./NoPricingFeatureDTO";
import { PrivacyPolicyFeatureDTO } from "./PrivacyPolicyFeatureDTO";
import { QuizFeatureDTO } from "./QuizFeatureDTO";
import { RedirectMyCoursesLoginDTO } from "./RedirectMyCoursesLoginDTO";
import { ReviewFeatureDTO } from "./ReviewFeatureDTO";
import { SharedCalendarFeatureDTO } from "./SharedCalendarFeatureDTO";
import { StorageFeatureDTO } from "./StorageFeatureDTO";
import { SubPlatformFeatureDTO } from "./SubPlatformFeatureDTO";
import { TermsOfUseFeatureDTO } from "./TermsOfUseFeatureDTO";
import { VideoChatFeatureDTO } from "./VideoChatFeatureDTO";
import { VideoUploadFeatureDTO } from "./VideoUploadFeatureDTO";

export class SubscriptionFeaturesDTO {
    quiz: QuizFeatureDTO;
    videoChat: VideoChatFeatureDTO;
    review: ReviewFeatureDTO;
    checkout: CheckoutFeatureDTO;
    canRegister: CanRegisterFeatureDTO;
    coursesCatalog: CoursesCatalogFeatureDTO;
    redirectMyCoursesLogin: RedirectMyCoursesLoginDTO;
    sharedCalendar: SharedCalendarFeatureDTO;
    videoUpload: VideoUploadFeatureDTO;
    storage: StorageFeatureDTO;
    gamification: GamificationFeatureDTO;
    editCustomerEmail: EditCustomerEmailFeatureDTO;
    noPricing: NoPricingFeatureDTO;
    coursesMatch: MatchFeatureDTO;
    communication: CommunicationFeatureDTO;
    termsOfUse: TermsOfUseFeatureDTO;
    privacyPolicy: PrivacyPolicyFeatureDTO;
    disableFeatured: DisableFeaturedFeatureDTO;
    disableMyCourses: DisableMyCoursesFeatureDTO;
    externalCatalog: ExternalCatalogFeatureDTO;
    subPlatform: SubPlatformFeatureDTO;

    constructor(obj?) {
        obj = obj || {};

        this.quiz = new QuizFeatureDTO(obj.quiz);
        this.videoChat = new VideoChatFeatureDTO(obj.videoChat);
        this.review = new ReviewFeatureDTO(obj.review);
        this.checkout = new CheckoutFeatureDTO(obj.checkout);
        this.canRegister = new CanRegisterFeatureDTO(obj.canRegister);
        this.coursesCatalog = new CoursesCatalogFeatureDTO(obj.coursesCatalog);
        this.redirectMyCoursesLogin = new RedirectMyCoursesLoginDTO(obj.redirectMyCoursesLogin);
        this.sharedCalendar = new SharedCalendarFeatureDTO(obj.sharedCalendar);
        this.videoUpload = new VideoUploadFeatureDTO(obj.videoUpload);
        this.storage = new StorageFeatureDTO(obj.storage);
        this.gamification = new GamificationFeatureDTO(obj.gamification);
        this.editCustomerEmail = new EditCustomerEmailFeatureDTO(obj.editCustomerEmail);
        this.noPricing = new NoPricingFeatureDTO(obj.noPricing);
        this.coursesMatch = new MatchFeatureDTO(obj.coursesMatch);
        this.communication = new CommunicationFeatureDTO(obj.communication);
        this.termsOfUse = new TermsOfUseFeatureDTO(obj.termsOfUse);
        this.privacyPolicy = new PrivacyPolicyFeatureDTO(obj.privacyPolicy);
        this.disableFeatured = new DisableFeaturedFeatureDTO(obj.disableFeatured);
        this.disableMyCourses = new DisableMyCoursesFeatureDTO(obj.disableMyCourses);
        this.externalCatalog = new ExternalCatalogFeatureDTO(obj.externalCatalog);
        this.subPlatform = new SubPlatformFeatureDTO(obj.subPlatform);
    }
}
